import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This key is used to track useTrayListQuery
 */
export const TRAY_FILTER_QUERY_KEY = 'tray-filter-list-query-key';

/**
 * This hook fetches the tray list.
 */
export const useTrayFiltersListQuery = (enabled: boolean) => {
  const { data, error, isError, isFetching, isPending, refetch } =
    useQueryWithUserId({
      enabled,
      queryKey: [TRAY_FILTER_QUERY_KEY],
      networkMode: 'always',
      retry: false,
      queryFn: INV_MGMT_SERVICE_API.getTrayFilters,
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
};
